// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"10":"78557001","279":"b9582004","310":"7caa543b","318":"04071432","965":"18f3e043"}[chunkId] + ".chunk.css";
};